/* eslint-disable max-lines-per-function */
/* eslint-disable complexity */
import { TFunction } from 'i18next';
import { handleGraphQLErrors } from '../../../../utils/errors/handleGraphQLErrors';
import {
  Arbeitszeiten,
  ArbeitszeitUpdateArbeitsbereichNotFound,
  ArbeitszeitUpdateArbeitszeitNotFound,
  ArbeitszeitUpdateBeginnVorEnde,
  ArbeitszeitUpdateIdArbeitsbereichNull,
  ArbeitszeitUpdateInvalidPauseDauer,
  ArbeitszeitUpdateManagerHasNoAccessToArbeitsbereich,
  ArbeitszeitUpdateManagerNotFound,
  ArbeitszeitUpdateMonatAbgeschlossen,
  ArbeitszeitUpdateMutation,
  ArbeitszeitUpdateOtherValidationError,
  ArbeitszeitUpdateResult,
  ArbeitszeitUpdateStaleState,
  UnknownError,
} from '../../../../gql/graphql';
import { toast } from '@/hooks/use-toast';
import * as Sentry from '@sentry/react';

function getErrorMessage(updateErrorResult: ArbeitszeitUpdateResult) {
  let message = '';
  if (
    updateErrorResult.__typename ===
      'ArbeitszeitUpdateArbeitsbereichNotFound' ||
    updateErrorResult.__typename === 'ArbeitszeitUpdateIdArbeitsbereichNull'
  ) {
    message =
      'domain.arbeitszeiten.sheet.header.arbeitszeitArbeitsbereichUpdateError';
  } else if (
    updateErrorResult.__typename === 'ArbeitszeitUpdateArbeitszeitNotFound'
  ) {
    message =
      'domain.arbeitszeiten.sheet.header.arbeitszeitNotFoundUpdateError';
  } else if (
    updateErrorResult.__typename ===
    'ArbeitszeitUpdateManagerHasNoAccessToArbeitsbereich'
  ) {
    message =
      'domain.arbeitszeiten.sheet.header.arbeitszeitManagerHasNoAccessToArbeitsbereichUpdateError';
  } else if (
    updateErrorResult.__typename === 'ArbeitszeitUpdateBeginnVorEnde'
  ) {
    message =
      'domain.arbeitszeiten.sheet.header.arbeitszeitBeginnVorEndeUpdateError';
  } else if (
    updateErrorResult.__typename === 'ArbeitszeitUpdateInvalidPauseDauer'
  ) {
    message =
      'domain.arbeitszeiten.sheet.header.arbeitszeitInvalidPauseDauerUpdateError';
  } else if (
    updateErrorResult.__typename === 'ArbeitszeitUpdateManagerNotFound'
  ) {
    message =
      'domain.arbeitszeiten.sheet.header.arbeitszeitManagerNotFoundUpdateError';
  } else if (
    updateErrorResult.__typename === 'ArbeitszeitUpdateMonatAbgeschlossen'
  ) {
    message =
      'domain.arbeitszeiten.sheet.header.arbeitszeitMonatAbgeschlossenUpdateError';
  } else if (
    updateErrorResult.__typename === 'ArbeitszeitUpdateOtherValidationError'
  ) {
    message =
      'domain.arbeitszeiten.sheet.header.arbeitszeitOtherValidationErrorUpdateError';
  } else if (updateErrorResult.__typename === 'ArbeitszeitUpdateStaleState') {
    message =
      'domain.arbeitszeiten.sheet.header.arbeitszeitStaleStateUpdateError';
  } else {
    message = 'domain.arbeitszeiten.sheet.header.arbeitszeitUpdateUnknownError';
  }
  return message;
}

export function handleOnCompleted(
  updateResult: ArbeitszeitUpdateMutation,
  t: TFunction,
) {
  const updateError = handleGraphQLErrors<
    Arbeitszeiten,
    | UnknownError
    | ArbeitszeitUpdateArbeitsbereichNotFound
    | ArbeitszeitUpdateArbeitszeitNotFound
    | ArbeitszeitUpdateBeginnVorEnde
    | ArbeitszeitUpdateIdArbeitsbereichNull
    | ArbeitszeitUpdateInvalidPauseDauer
    | ArbeitszeitUpdateManagerNotFound
    | ArbeitszeitUpdateMonatAbgeschlossen
    | ArbeitszeitUpdateOtherValidationError
    | ArbeitszeitUpdateManagerHasNoAccessToArbeitsbereich
    | ArbeitszeitUpdateStaleState
  >(updateResult.updateArbeitszeit);

  if (updateError) {
    Sentry.captureException(
      new Error(`${updateError.type}:${updateError.message}`),
    );
    const message = getErrorMessage(updateResult.updateArbeitszeit);
    toast({
      title: t(message),
    });
  } else {
    toast({
      title: t('domain.arbeitszeiten.sheet.arbeitszeit.edit.erfolgreich'),
    });
  }
}
